<script setup>
import { useWindowSize } from '@vueuse/core';
const { width } = useWindowSize();
</script>

<template>
  <div class="placeholder">
    <img :src="require('@/assets/img/label-s.png')" class="placeholder__label" v-if="width > 729">
    <img :src="require('@/assets/img/label-mobile-s.png')" class="placeholder__label" v-else>
    <img :src="require('@/assets/img/logo.svg')" class="placeholder__logo">
    <div class="placeholder__inner">
      <div class="placeholder__image">
        <img :src="require('@/assets/img/placeholder-image-spring.png')" alt="">
      </div>
      <div class="placeholder__text">
        <!--h2>Скоро здесь появятся бариста
        и&nbsp;вкусные коктейли с&nbsp;кофе
        НЕСКАФЕ®&nbsp;<span>ГОЛД</span>.<br/>
          Возвращайся в&nbsp;ноябре.</h2-->

        <h2>Спасибо за&nbsp;интерес!<br/>
          Акция уже завершена, <br/>
          следите за&nbsp;новыми <br/>
          предложениями от&nbsp;НЕСКАФÉ<sup>®</sup>.</h2>
        <p class="placeholder__note">Способ сервировки</p>
      </div>
    </div>
    <p class="placeholder__note placeholder__note_mobile">Способ сервировки</p>
  </div>
</template>